/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createLgamma } from '../../factoriesAny.js';
export var lgammaDependencies = {
  ComplexDependencies,
  typedDependencies,
  createLgamma
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesLgamma.generated.js
// module id = 1397
// module chunks = 2